import isPublicView from "app/utils/publicViewUtils";
import cx from "classnames";
import type { Element } from "React";
import { Component } from "react";
import type { NotificationType } from "../../../../types/notificationType";
import { IconClose } from "../../../Icon/Icon";
import "./Notification.scss";

type Props = {
  notification: NotificationType;
  onClose: (...args: Array<any>) => any;
};

class Notification extends Component<Props> {
  render(): Element<"div"> {
    const { notification } = this.props;

    return (
      <div
        className={cx(
          "notification",
          {
            "notification--urgent": notification.urgent,
          },
          {
            "notification--public": isPublicView(),
          }
        )}
      >
        <div className="notification__left-block" />
        <div className="notification__text">{notification.text}</div>
        {!isPublicView() && (
          <div
            className="notification__close-button"
            onClick={() => {
              this.props.onClose(notification.id);
            }}
          >
            <IconClose />
          </div>
        )}
      </div>
    );
  }
}

export default Notification;
